<article class="wrapper__article">
    <div class="wrapper__article__content">
        <mat-tab-group (selectedIndexChange)="onSelectTab($event)">
          <mat-tab *ngFor="let tab of paymentTabs | keyvalue: asIsOrder" [label]="tab.value">
            <app-cargo-list-payments *ngIf="activeTab == tab.value" [typeList]="tab.key"></app-cargo-list-payments>
          </mat-tab>
        </mat-tab-group>
    </div>
</article>
